// extracted by mini-css-extract-plugin
export default {"container":"topIndustryPlayers_container__FIkcz","item":"topIndustryPlayers_item__v94yT"};